export default class ClickTrack {
    constructor(el) {
        this.el = el
        let trackingData = el.dataset.tracking.split(',')
        this.event = trackingData[0]
        this.category = trackingData[1]
        this.action = trackingData[2]
        this.label = trackingData[3] ?? ''
        this._setupTracking()
    }

    _setupTracking() {
        this.el.addEventListener('click', () => {
            ClickTrack.track(this.event, this.category, this.action, this.label)
        })
    }

    static track(event, category, action, label = '') {
        if (window.dataLayer) {
            let trackingData = {
                'event': event,
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label
            }
            console.log('send datalayer', trackingData)
            let dataLayer = window.dataLayer
            dataLayer.push(trackingData)
        } else {
            console.warn('No datalayer to send events')
        }
    }
}
